import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            关于被窝影院的使用和追剧相关问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <div className="p-5 md:p-6">
                <div className="flex items-start gap-4">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 shrink-0 mt-0.5">
                    <span className="text-sm font-bold">Q</span>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900">
                      {item.q}
                    </h3>
                    <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                      {item.a}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}